module.exports = __webpack_public_path__ + "static/media/lock.ff8e3516.svg";